export default __webpack_public_path__ + "components/weather-icon/static/nightrainshowers-11cc50bc5fd530a675b179a9ffef1f87.webp";